import moment from 'moment'
// 毫秒数转化成时间
import transformContinuedTime from './lib/transformContinuedTime'

let yunMoment = moment

export default yunMoment

export {
  transformContinuedTime
}